import { render, staticRenderFns } from "./salesList.vue?vue&type=template&id=e1272a64&scoped=true"
import script from "./salesList.vue?vue&type=script&lang=js"
export * from "./salesList.vue?vue&type=script&lang=js"
import style0 from "./salesList.vue?vue&type=style&index=0&id=e1272a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1272a64",
  null
  
)

export default component.exports